<template>
  <div class="product-list">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addPreSaleScheme()">添加预售方案
          </el-button>
        </el-form-item>
        <el-form-item label="方案名称">
          <el-input size="small" v-model="searchForm.title" placeholder="请输入方案名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="title" label="方案名称" width="240px"></el-table-column>
          <el-table-column prop="productName" label="预售产品">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.imagePath" alt=""/></div>
                <div class="info">
                  <div class="name">{{ scope.row.productName }}</div>
                  <div class="price">￥{{ scope.row.productPrice }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="presellStartTime" label="开始时间" width="150"></el-table-column>
          <el-table-column prop="presellEndTime" label="结束时间" width="150"></el-table-column>
          <el-table-column prop="expectDeliveryTime" label="预计发货时间" width="150"></el-table-column>
          <el-table-column prop="createTime" label="添加时间" width="150"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
    <el-dialog :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" title="预售方案"
               :close-on-press-escape="false" width="40%">
      <el-form size="small" ref="form" :model="form" :rules="formRules" label-width="120px"
               v-loading="loading">
        <el-form-item label="预售方案标题：" prop="title">
          <el-input v-model="form.title" size="small" placeholder="请输入预售方案标题"></el-input>
        </el-form-item>
        <el-form-item label="商品名称：" prop="productId">
          <div class="table-wrap">
            <el-button @click="onProductChoose">选择商品</el-button>
            <el-table size="small" :data="form.tableData" border style="width: 100%;margin-top: 15px">
              <el-table-column prop="productName" label="商品名称">
                <template slot-scope="scope">
                  <div class="product-info">
                    <div class="pic"><img v-img-url="scope.row.imagePath" alt=""/></div>
                    <div class="info">
                      <div class="name">{{ scope.row.productName }}</div>
                      <div class="price">￥{{ scope.row.productPrice }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="预售起止时间：" prop="presellStartTime">
          <el-date-picker
            size="small"
            v-model="presellTime"
            type="datetimerange"
            value-format="yyyy-MM-dd hh:mm:ss"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="预计发货时间：" prop="expectDeliveryTime">
          <el-date-picker
            size="small"
            v-model="form.expectDeliveryTime"
            type="datetime"
            value-format="yyyy-MM-dd hh:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <!--        <el-form-item label="预计到货时间："-->
        <!--                      prop="form.arrivalTime">-->
        <!--          <div class="d-s-c">-->
        <!--            <el-input-number v-model="form.arrivalTime" @change="handleArrivalTimeChange" :min="1"-->
        <!--                             label=""></el-input-number>-->
        <!--            <span class="ml10">天</span>-->
        <!--          </div>-->
        <!--        </el-form-item>-->
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addClickOK">确 定</el-button>
      </div>
    </el-dialog>
    <getproduct :isProduct="open_product" :dataType="2" :islist="false" @closeDialog="closeDialogFunc($event)"/>
  </div>
</template>

<script>
import getproduct from '@/components/product/Product.vue'
import ProductApi from '@/api/product.js'

export default {
  name: 'index',
  components: {getproduct},
  data () {
    return {
      searchForm: {
        title: '',
      },
      open_product: false,
      loading: false,
      tableData: [],
      dialogVisible: false,
      form: {
        id: 0,
        title: '',
        productId: '',
        presellStartTime: '',
        presellEndTime: '',
        arrivalTime: 1,
        tableData: []
      },
      formRules: {
        title: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }],
        productId: [{
          required: true,
          message: '商品不能为空',
          trigger: 'change'
        }],
        presellStartTime: [{
          required: true,
          message: '预售时间不能为空',
          trigger: 'change'
        }],
        expectDeliveryTime: [{
          required: true,
          message: '预计发货时间不能为空',
          trigger: 'change'
        }]
      },
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
    }
  },
  computed: {
    presellTime: {
      get () {
        return [this.form.presellStartTime || '', this.form.presellEndTime || '']
      },
      set (e) {
        if (e && e.length > 1) {
          this.form.presellStartTime = e[0] || ''
          this.form.presellEndTime = e[1] || ''
        } else {
          this.form.presellStartTime = ''
          this.form.presellEndTime = ''
        }

      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getData()
    },
    getData () {
      let self = this
      self.loading = true
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize

      ProductApi.supplierPresaleList(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.records
          self.totalDataNumber = res.data.total
        })
        .catch(error => {
          self.loading = false
        })
    },
    addPreSaleScheme () {
      this.form = {
        id: 0,
        title: '',
        productId: '',
        presellStartTime: '',
        presellEndTime: '',
        arrivalTime: 1,
        expectDeliveryTime: '',
        tableData: []
      }
      this.dialogVisible = true
    },
    editClick (row) {
      this.form = {
        id: row.id || 0,
        title: row.title || '',
        productId: row.productId || '',
        presellStartTime: row.presellStartTime || '',
        presellEndTime: row.presellEndTime || '',
        expectDeliveryTime: row.expectDeliveryTime || '',
        arrivalTime: row.arrivalTime || 1,
        tableData: [{
          productId: row.productId || '',
          productName: row.productName || '',
          imagePath: row.imagePath || '',
          productPrice: row.productPrice || '',
        }]
      }
      this.dialogVisible = true
    },
    onSubmit () {
      this.curPage = 1
      this.getData()
    },
    dialogFormVisible () {
      this.dialogVisible = false
    },
    addClickOK () {
      let self = this
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = self.form
          ProductApi.addsupplierPresale(params, true)
            .then(res => {
              this.getData()
              this.dialogFormVisible()
            })
            .catch(error => {

            })

        }
      })
    },
    handleArrivalTimeChange (e) {
      console.log('handleArrivalTimeChange = ' + e)
      if (e === undefined) {
        this.$nextTick(() => {
          this.form.arrivalTime = 1
        })
      }
    },
    onProductChoose () {
      this.open_product = true
    },
    closeDialogFunc (e) {
      if (e.type !== 'error') {
        let params = e.params
        this.form.productId = params.productId
        this.$emit('change', this.form.productId)
        this.form.tableData = [params]
      }
      this.open_product = false
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.loading = true
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.pageSize = val
      this.getData()
    },
    delClick (row) {

      let self = this
      self.$confirm('删除后不可恢复，确认删除该预售方案?', '提示', {
        type: 'warning'
      }).then(() => {
        ProductApi.delSupplierPresale({
          id: row.id
        }, true).then(data => {
          self.$message({
            message: '删除成功',
            type: 'success'
          })
          self.getData()
        })
      })

    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/product/activity/presale/index.vue